import axiosClient from './axiosClient';

export const authApi = {
  login(payload) {
    return axiosClient.post('/auth/login', {
      ...payload,
      device_name: 'manager-dashboard',
    });
  },

  me() {
    return axiosClient.get('/auth/me');
  },

  logout() {
    return axiosClient.post('/auth/logout');
  },

  logoutAll() {
    return axiosClient.post('/auth/logout-all');
  },
};

export default authApi;